


export const quotationProductColumns = [
  {
    title: 'Product',
    dataIndex: 'product_id',
    editable: true,
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
    width: '15%'
  },
  {
    title: 'Description',
    dataIndex: 'description',
    editable: true,
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
    width: '15%'
  },
  {
    title: 'Quantity',
    dataIndex: 'quantity',
    editable: true,
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
    width: '10%'
  },
  {
    title: 'Packaging Quantity',
    dataIndex: 'packaging_quantity',
    editable: true,
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
    width: '10%'
  },
  {
    title: 'Packaging',
    dataIndex: 'packaging_id',
    editable: true,
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
    width: '10%'
  },
  {
    title: 'Price',
    dataIndex: 'price',
    editable: true,
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
    width: '10%'
  },
  {
    title: 'Taxes',
    dataIndex: 'taxes',
    editable: true,
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
    width: '10%'
  },
  {
    title: 'Subtotal',
    dataIndex: 'subtotal',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
    width: '10%'
  },
  {
    title: '',
    width: '100px',
    fixed: 'right',
  }
];

export const poColumns = [
  {
    title: 'Product',
    dataIndex: 'product_id',
    editable: true,
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
    width: '15%'
  },
  {
    title: 'Description',
    dataIndex: 'description',
    editable: true,
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
    width: '15%'
  },
  {
    title: 'Quantity',
    dataIndex: 'quantity',
    editable: true,
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
    width: '10%'
  },
  {
    title: 'Received Quantity',
    dataIndex: 'received_quantity',
    editable: true,
    ellipsis: true,
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
    width: '10%'
  },
  {
    title: 'Billed Quantity',
    dataIndex: 'billed_quantity',
    editable: true,
    ellipsis: true,
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
    width: '10%'
  },
  {
    title: 'Packaging Quantity',
    dataIndex: 'packaging_quantity',
    editable: true,
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
    width: '10%'
  },
  {
    title: 'Packaging',
    dataIndex: 'packaging_id',
    editable: true,
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
    width: '10%'
  },
  {
    title: 'Price',
    dataIndex: 'price',
    editable: true,
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
    width: '10%'
  },
  {
    title: 'Taxes',
    dataIndex: 'taxes',
    editable: true,
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
    width: '10%'
  },
  {
    title: 'Subtotal Received Quantity',
    dataIndex: 'received_quantity_subtotal',
    editable: true,
    ellipsis: true,
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
    width: '10%'
  },
  {
    title: 'Subtotal',
    dataIndex: 'subtotal',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
    width: '10%'
  },
  {
    title: '',
    width: '100px',
    fixed: 'right',
  }
];

export const optionalColumns = [
  {
    title: 'Product',
    dataIndex: 'product_id',
    editable: true,
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
    // width: '15%'
  },
  {
    title: 'Description',
    dataIndex: 'description',
    editable: true,
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
    // width: '15%'
  },
  {
    title: 'Quantity',
    dataIndex: 'quantity',
    editable: true,
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
    // width: '10%'
  },
  {
    title: 'Price',
    dataIndex: 'price',
    editable: true,
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
    // width: '10%'
  },
  {
    title: '',
    width: '100px',
    fixed: 'right',
  }
]

export const detailedOperationColumns = [
  {
    title: 'Product',
    dataIndex: 'product_id',
    editable: true,
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
    width: '20%'
  },
  {
    title: 'From',
    dataIndex: 'source_location',
    editable: true,
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
    width: '15%'
  },
  {
    title: 'To',
    dataIndex: 'destination_location',
    editable: true,
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
    width: '15%'
  },
  {
    title: 'Source Package',
    dataIndex: 'source_package',
    editable: true,
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
    width: '10%'
  },
  {
    title: 'Destination Package',
    dataIndex: 'destination_package',
    editable: true,
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
    width: '10%'
  },
  {
    title: 'Lot/Serial Number',
    dataIndex: 'lot_serial_number_id',
    editable: true,
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
    width: '10%'
  },
  {
    title: 'Reserved',
    dataIndex: 'reserved_quantity',
    editable: true,
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
    width: '10%'
  },
  {
    title: 'Done',
    dataIndex: 'done_quantity',
    editable: true,
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
    width: '10%'
  },
  {
    title: ''
  }
];


export const operationColumns = [
  {
    title: 'Product',
    dataIndex: 'product_id',
    editable: true,
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
    width: '20%'
  },
  {
    title: 'Description',
    dataIndex: 'description',
    editable: true,
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
    width: '15%'
  },
  {
    title: 'Packaging',
    dataIndex: 'packaging_id',
    editable: true,
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
    width: '15%'
  },
  {
    title: 'Demand',
    dataIndex: 'demand_quantity',
    editable: true,
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
    width: '10%'
  },
  {
    title: 'Done',
    dataIndex: 'done_quantity',
    editable: true,
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
    width: '10%'
  },
  {
    title: 'Reserved',
    dataIndex: 'reserved_quantity',
    editable: true,
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
    width: '10%'
  },
  {
    title: 'Deadline',
    dataIndex: 'deadline_date',
    editable: true,
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
    width: '10%'
  },
  {
    title: ''
  }
]


export const productPurchaseTabColumns = [
  {
    title: 'Vendor',
    dataIndex: 'vendor_id',
    editable: true,
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
    width: '30%'
  },
  {
    title: 'Quantity',
    dataIndex: 'quantity',
    editable: true,
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
    width: '30%'
  },
  {
    title: 'Price',
    dataIndex: 'price',
    editable: true,
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
    width: '30%'
  },
  {
    title: ''
  }
];


export const productPackagingColumns = [
  {
    title: 'Packaging',
    dataIndex: 'packaging',
    editable: true,
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
    width: '44%'
  },
  {
    title: 'Contained Quantity',
    dataIndex: 'conatained_quantity',
    editable: true,
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
    width: '44%'
  },
  {
    title: ''
  }
]

